import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=f698d1b4&scoped=true&"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=f698d1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f698d1b4",
  null
  
)

export default component.exports